import type { ReactNode } from 'react';
import { BrandLogo } from './BrandLogo';

/** Centered card for the sign-in / sign-up / recovery screens. */
export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div className="relative min-h-dvh overflow-hidden">
      {/* Decorative brand shapes (teal, green, orange) behind the card. */}
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <span className="absolute -top-24 -left-24 size-72 rounded-full bg-brand-soft" />
        <span className="absolute top-1/3 -right-20 size-56 rounded-full bg-accent-soft" />
        <span className="absolute -bottom-16 left-1/4 size-40 rounded-full bg-orange-soft" />
      </div>
      <main className="relative mx-auto flex min-h-dvh w-full max-w-md flex-col justify-center gap-6 px-4 py-10">
        <div className="flex flex-col items-center gap-3 text-center">
          <span className="flex size-24 items-center justify-center rounded-3xl bg-surface shadow-[var(--shadow-card)]">
            <BrandLogo size={64} wordmark={false} />
          </span>
          <h1 className="text-2xl sm:text-3xl">{title}</h1>
          {subtitle ? <p className="text-sm text-muted">{subtitle}</p> : null}
        </div>
        <div className="card flex flex-col gap-4 p-5 sm:p-6">{children}</div>
      </main>
    </div>
  );
}
